import { selectors } from 'modules/common';
import { useSelector } from 'modules/react-redux';
import moment from 'moment';
import { useMemo } from 'react';

import { PrintPreviewPopupData } from '../../../../reducers/page/printPreviewPopupReducer';
import { getActivePopup } from '../../../../selectors/pageSelectors';
import { getDefinitionByKind } from '../../../../selectors/reportConfigSelectors';
import { ReportConfigExpanded } from '../../../../types/ReportConfig';

export const useContentScreen = (report: ReportConfigExpanded, company: selectors.types.ExpandedCompany) => {
    const printPreviewData = useSelector((state) => getActivePopup<PrintPreviewPopupData>(state));

    return useMemo(
        () => ({
            dateTime: moment().format('lll'),
            rows: printPreviewData?.rows || [],
            columnsDefinition: (report?.columns || [])
                .filter((column) => column.visible)
                .map((column) => ({
                    columnDefinition: getDefinitionByKind(column.kind, report, company),
                    column,
                })),
        }),
        [company, printPreviewData?.rows, report]
    );
};
